import { useEffect, useState } from "react";
import { IUserData, TUserDataKeys } from "./hooks/useSignUp";
import { AUTH_CODE_RESEND_TIMEOUT } from "../../../../../lib/constants";
import { transformPhone } from "../../../../../lib/utils";
import { Input } from "../../../../ui/input";
import Button from "../../../../ui/button";
import InputNumber from "../../../../ui/input/input-number";
import useAuthUserSingUp from "../../../../../api/hooks/hooks-auth/use-auth-user-signUp";

import style from "./styles.module.scss";
import clsx from "clsx";
import { CheckBox } from "../../../../ui/checkbox/checkboxMain";
import { Link } from "react-router-dom";

interface IUserFormProps {
  onChange: (value: TUserDataKeys, key: string | boolean) => void;
  data: IUserData;
  onSendData: () => void;
  isDisable: boolean;
}

const UserForm = ({
  data,
  isDisable,
  onChange,
  onSendData,
}: IUserFormProps) => {
  const [isConfirm, setIsConfirm] = useState(false);
  const [time, setTime] = useState(AUTH_CODE_RESEND_TIMEOUT);
  const [timerActive, setTimerActive] = useState(false);

  const validateNumberPhone = () => {
    const regPhone = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/;
    if (data.numberPhone && regPhone.test(data.numberPhone)) {
      return true;
    }
    return false;
  };

  const {
    data: dataAuthNumPhoneData,
    error: dataAuthNumPhoneError,
    isMutating: dataAuthNumPhoneIsMutating,
    trigger: dataAuthNumPhoneTrigger,
  } = useAuthUserSingUp();

  useEffect(() => {
    if (dataAuthNumPhoneData?.code) {
      onChange("otp", dataAuthNumPhoneData?.code);
    }
  }, [dataAuthNumPhoneData]);

  useEffect(() => {
    if (timerActive) {
      const timerID = setInterval(() => {
        if (time) {
          setTime((prev) => {
            if (prev === 0) {
              clearInterval(timerID);
              setTime(AUTH_CODE_RESEND_TIMEOUT);
              setTimerActive(false);
              return prev;
            }
            return prev - 1;
          });
        }
      }, 1000);

      return () => clearInterval(timerID);
    }
  }, [timerActive]);

  const onClickConfirmPhone = async () => {
    try {
      if (data.numberPhone) {
        setIsConfirm(true);
        await dataAuthNumPhoneTrigger({
          phone: transformPhone(data.numberPhone),
          marketingConsent: data.marketingConsent,
          personalDataConsent: data.personalDataConsent,
          privacyPolicyConsent: data.privacyPolicyConsent,
        });
        setTimerActive(true);
      }
    } catch (error) {}
  };

  const isShowButton = !Boolean(
    validateNumberPhone() &&
      data.firstName &&
      data.lastName &&
      data.personalDataConsent &&
      data.privacyPolicyConsent
  );

  return (
    <div className={style.formRequestUser}>
      <div className={style.formRequestUser__container}>
        <div className={style.formRequestUser__title}>
          <h3>{"Заполните форму ниже чтобы зарегистрироваться:"}</h3>
        </div>
        <div className={style.formRequestUser__phone}>
          <Input
            name={"confirm-number-phone-sign-up"}
            autoFocus
            label="Номер телефона"
            type="tel"
            onChange={(value) => onChange("numberPhone", value)}
            placeholder="Например: 89500561452"
            value={data.numberPhone}
            isMainPlaceholder
          />
          <div
            className={clsx(
              style.formRequestUser__phoneConfirm,
              isShowButton && style.formRequestUser__phoneConfirm_hide
            )}
          >
            <Button
              onClick={onClickConfirmPhone}
              label={
                time === AUTH_CODE_RESEND_TIMEOUT ? "подтвердить" : `${time} c`
              }
              style={{ height: "38px", fontSize: 15, paddingBottom: "30px" }}
              disabled={time !== AUTH_CODE_RESEND_TIMEOUT}
            />
          </div>
        </div>
        {isConfirm && (
          <div className={style.formRequestUser__opt}>
            <InputNumber
              mode="otp"
              label="Код подтверждения"
              onChange={(value) => onChange("otp", value)}
              length={6}
              placeholder="Например: 123456"
              value={data.otp}
              isMainPlaceholder
            />
          </div>
        )}
        <div className={style.formRequestUser__fio}>
          <Input
            label="Фамилия"
            onChange={(value) => onChange("lastName", value)}
            placeholder="Например: Иванов"
            value={data.lastName}
            isMainPlaceholder
          />
        </div>
        <div className={style.formRequestUser__fio}>
          <Input
            label="Имя"
            onChange={(value) => onChange("firstName", value)}
            placeholder="Например: Иван"
            value={data.firstName}
            isMainPlaceholder
          />
        </div>
        <div className={style.formRequestUser__fio}>
          <Input
            label="Отчество"
            onChange={(value) => onChange("patronymic", value)}
            placeholder="Например: Иванович"
            value={data.patronymic}
            isMainPlaceholder
          />
        </div>

        <div className={style.formRequestUser__politics}>
          <div style={{ display: "flex", gap: "4px" }}>
            <CheckBox
              checked={data.personalDataConsent}
              onChange={(value) => onChange("personalDataConsent", value)}
            />
            <div>
              <span>Я предоставляю свое согласие на </span>
              <Link
                target={"_blank"}
                to={"https://reit-invest.ru/privacy_policy"}
              >
                обработку персональных данных
              </Link>
            </div>
          </div>

          <div style={{ display: "flex", gap: "4px" }}>
            <CheckBox
              checked={data.privacyPolicyConsent}
              onChange={(value) => onChange("privacyPolicyConsent", value)}
            />
            <div>
              <span>Я соглашаюсь с </span>
              <Link target={"_blank"} to={"https://reit-invest.ru/consent"}>
                политикой конфиденциальности
              </Link>
            </div>
          </div>

          <div style={{ display: "flex", gap: "4px" }}>
            <CheckBox
              checked={data.marketingConsent}
              onChange={(value) => onChange("marketingConsent", value)}
            />
            <div>
              <span>Я даю согласие на </span>
              <Link target={"_blank"} to={"https://reit-invest.ru/rek"}>
                рекламную рассылку
              </Link>
            </div>
          </div>
        </div>

        <div className={style.formRequestUser__mark}>
          Будьте спокойны, мы не будем отправлять вам рекламу и спам!
        </div>

        <div className={style.formRequestUser__button}>
          <Button
            label="Зарегистрироваться"
            onClick={onSendData}
            disabled={isDisable}
          />
        </div>
      </div>
    </div>
  );
};

export default UserForm;
